export default __webpack_public_path__ + "static/image-66-7c26081abbf1f09eb47771309ed91746.jpg";